<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="infoRoute.name">
        </base-page-header>

        <v-row class="bg-white" style="border-radius: 7px" >
            <v-col cols="12" sm="6">
                <span>
                    {{transporterInfo.nif}} - {{transporterInfo.name}}
                </span>
            </v-col>
            <v-col cols="12" sm="6" class="text-md-right text-center ">
                <v-row>
                    <v-col cols="4"></v-col>
                    <v-col cols="3" class="d-flex align-center justify-end" style="justify-content: flex-end; ">
                        <img src="/images/_SVGs/environmental/oficinas.svg" width="20" height="20" onload="SVGInject(this)" class="mr-3"/>
                        {{egars.length}}
                    </v-col>
                    <v-col cols="5" class="d-flex align-center justify-end">
                        <v-progress-linear value="100"></v-progress-linear>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" class="data-p">
                <v-data-table
                    :headers="headersActive"
                    :items="egars"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    item-key="egarId"

                    :hide-default-footer="true"
                    show-expand
                    class="elevation-1"
                >
                    <template v-slot:item.status="{ index, item }">
                        <span v-html="statusHandler(item, index)"></span>
                    </template>
                    <template v-slot:item.createDate="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.producer="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>

                    <template v-slot:item.morada="{ item }">
                        {{item.producer.address}} {{item.producer.locality}}
                    </template>
                    <template v-slot:item.transportedResidue="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:item.qtd="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" v-if="!item.routeEgarReason">
                            {{$t('environmental-management.route-management.no-info')}}
                        </td>
                        <td :colspan="headers.length" v-else style="color:var(--v-error-base); background-color: var(--v-error-lighten5)">
                            <b>{{$t('environmental-management.route-management.route-egar-reason')}}</b> {{item.routeEgarReason}}
                        </td>
                    </template>
                </v-data-table>
            </v-col>

            <v-col cols="12" sm="2">
                <div class="back ml-4" @click="$router.push({name: 'environmentalManagementRouteManagementHistory'})">
                    <div><img src="/images/_SVGs/back.svg" :alt="$t('back')" onload="SVGInject(this)" /></div>
                    <div>{{$t('back')}}</div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { GetTransporterToRoute } from '@services/b2b/environmental-management/RouterService'
    import { GetEgars } from '@services/b2b/environmental-management/EgarService'
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";
    export default {
        components: {BasePageHeader},
        data(){
            return{
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.title'),
                        routerLinkName: 'environmentalManagementRouteManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.view-history.title'),
                        routerLinkName: 'environmentalManagementRouteManagementHistory'
                    },
                    {
                        title: ''
                    }
                ],
                headersActive:[
                    {
                        text: '#',
                        value: 'status',
                    },
                    {
                        text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                        align: 'start',
                        value: 'createDate',
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd' },
                    { text: '', value: 'data-table-expand' },

                ],

                singleExpand: false,
                expanded: [],
                infoRoute:{
                    name: ''
                },
                transporterInfo: {
                    name: '',
                    nif: '',
                    plateNumber: '',
                    transportationStartDate: ''
                },
                egars: [],
                routes: [],

            }
        },
        methods:{
            statusHandler(item, index){
                if(item.routeEgarStatusID == 2){
                    return '<img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" class="mr-1 danger" width="20" height="20"/>'
                }else if(item.routeEgarStatusID == 1){
                    return '<img src="/images/_SVGs/environmental/check.svg" onload="SVGInject(this)" class="mr-1 successIcon" width="20" height="20"/>'
                }else{
                    return index + 1;
                }
            },
            getTransporter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetTransporterToRoute(this.$route.params.id)
                    .then(response => {

                        this.transporterInfo.name = response.data.result.name
                        this.transporterInfo.nif = response.data.result.nif
                        this.transporterInfo.plateNumber = response.data.result.plateNumber
                        this.transporterInfo.transportationStartDate = response.data.result.transportationStartDate

                        this.infoRoute.name = this.$route.params.name? this.$route.params.name : this.transporterInfo.name;
                        this.breadcrumb[3].title= this.$route.params.name? this.$route.params.name : this.transporterInfo.name;
                    })
                    .catch(error => {
                        throw new Error('error to get GetTransporterToRoute values', error);
                    })
                    .finally(() => {
                        this.getAllEGAR();
                    })
            },
            getAllEGAR(){

                this.filters= [];
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                    Object.assign(this.filters, {
                        pageSize: 150,
                        hasRoutes: true,
                        routeId: this.$route.params.id
                    }
                )
                return GetEgars(this.filters)
                    .then(response => {
                        this.egars = response.data.result
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.filters= [];
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
        },
        created(){
            this.getTransporter()
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.base-page-header-container{
    margin-bottom: 0;
}
.link-router{
    font-size: 12px;
    color: var(--v-primary-base);
    &:hover{
        font-weight: 600;
    }
}
.btn-primary-custom{
    text-transform: capitalize;
}
.btn-add{
    cursor: pointer;
}

.data-p{
    ::v-deep table{
        thead {

            th{
                font-size: 13px !important;
                border: 1px solid rgb(224 224 224);
                height: 30px !important;
                background: $grey-light;
                color:rgb(113 113 113 / 60%) !important;
            }
        }
        tbody{
            td{
                border: 1px solid rgb(224 224 224);
                font-size: 13px !important;
                p{
                    margin-bottom: 0;
                    &.subTitle-table{
                        margin-top: 3px;
                        color: #c5c2c2;
                    }
                }
            }
        }
    }
}

.circle{
    width: 30px;
    padding: 0px;
    width: 40px;
    background: var(--v-primary-base);
    ::v-deep path{
        fill: #ffffff !important;
    }
}
.subTitleCurso{
    font-size: 12px;
}
::v-deep .status-ok{
    path{
        fill: $green !important;
    }
}
::v-deep .status-nOk{
    path{
        fill: red !important;
    }
}

.rotation-180{
    transform: rotate(180deg);
}

.qtd-route{
    font-size: 14px;
    .current{
        font-size: 18px;
    }
}

.pendent{
    opacity: 0.3;
}
.cursor-pointer{
    cursor: pointer;
}
.button-delete{
    cursor: pointer;
    ::v-deep svg{
        g path{
            fill: red !important;
        }
    }
}

::v-deep svg.danger{
    path{
        fill: red !important;
    }
}

::v-deep svg.successIcon{
    path{
        fill: green !important;
    }
}
</style>
